import chiclayo from '../../assets/img/inicio_header.png'
import trujillo from '../../assets/img/trujillo.png'
import lima from '../../assets/img/lima.png'
import messageImage from '../../assets/img/message_icon.png'
import packageImage from '../../assets/img/package_icon.png'
import bagImage from '../../assets/img/bag_icon.png'

export const listOfferItem = [
    {
        id: 1,
        tour: 'Caballitos de totora',
        price: '232',
        title: 'Chiclayo',
        subTitle: 'Inigualable',
        image: chiclayo,
    },
    {
        id: 2,
        tour: 'Caballitos de totora',
        price: '232',
        title: 'Chiclayo',
        subTitle: 'Inigualable',
        image: trujillo,
    },
    {
        id: 3,
        tour: 'Caballitos de totora',
        price: '232',
        title: 'Chiclayo',
        subTitle: 'Inigualable',
        image: lima,
    },
    {
        id: 4,
        tour: 'Caballitos de totora',
        price: '232',
        title: 'Chiclayo',
        subTitle: 'Inigualable',
        image: chiclayo,
    },
]

export const listDestinationsItem = [
    {
        id: 1,
        tour: 'Turismo',
        image: chiclayo,
        title: 'Machu Picchu es todo un éxito tras su reapertura',
        subTitle: 'Turismo',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
    },
    {
        id: 2,
        tour: 'Turismo',
        image: trujillo,
        title: 'Machu Picchu es todo un éxito tras su reapertura',
        subTitle: 'Turismo',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
    },
    {
        id: 3,
        tour: 'Turismo',
        image: lima,
        title: 'Machu Picchu es todo un éxito tras su reapertura',
        subTitle: 'Turismo',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
    },
    {
        id: 4,
        tour: 'Turismo',
        image: chiclayo,
        title: 'Machu Picchu es todo un éxito tras su reapertura',
        subTitle: 'Turismo',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
    },
]

export const listFeature = [
    {
      id: 1,
      icon: messageImage,
      title: 'Experiencia 43 años',
      subTitle: 'al servicio del transporte',
      description: 'interprovincial'
    },
    {
      id: 2,
      icon: packageImage,
      title: 'Experiencia 43 años',
      subTitle: 'al servicio del transporte',
      description: 'interprovincial'
    },
    {
      id: 3,
      icon: bagImage,
      title: 'Experiencia 43 años',
      subTitle: 'al servicio del transporte',
      description: 'interprovincial'
    }
  ]